<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M33.5 6.5a1.5 1.5 0 00-3 0h3zm-1.5 51l-1.06 1.06a1.5 1.5 0 002.12 0L32 57.5zm18.56-16.44a1.5 1.5 0 00-2.12-2.12l2.12 2.12zm-35-2.12a1.5 1.5 0 00-2.12 2.12l2.12-2.12zM30.5 6.5v51h3v-51h-3zm2.56 52.06l17.5-17.5-2.12-2.12-17.5 17.5 2.12 2.12zm0-2.12l-17.5-17.5-2.12 2.12 17.5 17.5 2.12-2.12z"/></svg>